import TableCellText from "ds/components/Table/Row/CellText";

import EnvironmentTableCell from "../Cell";
import { EnvironmentVariableCellProps } from "./types";

const SecretCell = ({ item, ...cellProps }: EnvironmentVariableCellProps) => {
  return (
    <EnvironmentTableCell {...cellProps}>
      <TableCellText>{item.element.writeOnly ? "Secret" : "Plain"}</TableCellText>
    </EnvironmentTableCell>
  );
};

export default SecretCell;
